export enum ERequestDemandField {
  EMAIL = 'email',
  PHONE = 'phone',
  USER_TYPE = 'userType',
}
